export default __webpack_public_path__ + "static/media/historyIcon.3a7113e8.svg";